import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetPatronBadgeCountsByBadgeId = ({ id }: { id: number }) => {
  const get = useTypedApiClient({
    path: '/admin/patronbadgerewards/badge-counts/{badgeId}',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/admin/patronbadgerewards/badge-counts', id],
    queryFn: async () => {
      const { data } = await get({ badgeId: id })
      return data
    },
  })
}
